import ApiService from "@/services/api.service";
// import JwtService from "@/services/jwt.service";

// action types
export const GET_DEVICE = "getDevice";
export const GET_DEVICE_LAST = "getDeviceLast";
export const GET_DEVICE_COUNT = "getDeviceCount";
export const GET_DEVICE_STATUS = "getDeviceStatus";
export const GET_DEVICE_LOG_DETAIL = "getDeviceLogDetail";

// mutation types
export const SET_DEVICE = "device";
export const SET_DEVICE_LAST = "deviceLast";
export const SET_DEVICE_COUNT = "deviceCount";
export const SET_DEVICE_STATUS = "deviceStatus";
export const SET_DEVICE_LOG_DETAIL = "deviceLogDetail";
export const SET_ERROR = "setError";

const state = {
    errors: null,
    device: null,
    deviceLast: null,
    deviceLogDetail: null,
    deviceCount: null,
    deviceStatus: null,
};

const getters = {
    getDeviceCount(state) {
        return state.deviceCount;
    },
    getDeviceStatus(state) {
        return state.deviceStatus;
    },
    getDevice(state) {
        return state.device;
    },
    getDeviceLast(state) {
        return state.deviceLast;
    },
    getDeviceLogDetail(state) {
        return state.device_log_detail;
    },
};

const actions = {
    [GET_DEVICE](context) {
        return ApiService.get("device").then(({ data }) => {
            context.commit(SET_DEVICE, data);
            return data;
        });
    },
    [GET_DEVICE_LAST](context) {
        return ApiService.get("log_detail_device/1").then(({ data }) => {
            context.commit(SET_DEVICE_LAST, data);
            return data;
        });
    },
    [GET_DEVICE_COUNT](context) {
        return ApiService.get("counting_device").then(({ data }) => {
            context.commit(SET_DEVICE_COUNT, data);
            return data;
        });
    },
    [GET_DEVICE_STATUS](context) {
        return ApiService.get("status_device").then(({ data }) => {
            context.commit(SET_DEVICE_STATUS, data);
            return data;
        });
    },
    [GET_DEVICE_LOG_DETAIL](context) {
        return ApiService.get("log_detail_device/100").then(({ data }) => {
            context.commit(SET_DEVICE_LOG_DETAIL, data);
            return data;
        });
    },
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_DEVICE](state, data) {
        state.device = data;
    },
    [SET_DEVICE_LAST](state, data) {
        state.deviceLast = data;
    },
    [SET_DEVICE_COUNT](state, data) {
        state.deviceCount = data;
    },
    [SET_DEVICE_STATUS](state, data) {
        state.deviceStatus = data;
    },
    [SET_DEVICE_LOG_DETAIL](state, data) {
        state.deviceLogDetail = data;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
